import axios from "axios";
import { Cookies } from "react-cookie";
import { proxy } from "../config";
const cookie = new Cookies();

export const getSeparates = async (page) => {
  const token = await cookie.get("token");
  return await axios.get(
    `${proxy}/separates/all_separates_admin?page=${page}`,
    {
      headers: { Authorization: token },
    },
  );
};

export const searchSeparates = async (page, search) => {
  const token = await cookie.get("token");
  return await axios.get(
    `${proxy}/separates/search_separates_admin?page=${page}&&search=${search}`,
    {
      headers: { Authorization: token },
    },
  );
};

export const getSeparate = async (id) => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/separates/id?id=${id}`, {
    headers: { Authorization: token },
  });
};

export const getDataItems = async () => {
  const token = await cookie.get("token");
  return await axios.get(`${proxy}/separates/developers_and_names`, {
    headers: { Authorization: token },
  });
};

export const createSeparate = async (formData) => {
  const token = await cookie.get("token");
  return await axios.post(`${proxy}/separates/create_separate`, formData, {
    headers: { Authorization: token },
  });
};

export const updateSeparate = async (id, formData) => {
  const token = await cookie.get("token");
  return await axios.put(`${proxy}/separates/update?id=${id}`, formData, {
    headers: { Authorization: token },
  });
};

export const deleteSeparate = async (id) => {
  const token = await cookie.get("token");
  return await axios.delete(`${proxy}/separates/delete?id=${id}`, {
    headers: { Authorization: token },
  });
};

export const getExcel = async () => {
  const res = await fetch(`${proxy}/separates/excel`);
  const blob = await res.blob();

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Separates.xlsx";
  a.click();
  window.URL.revokeObjectURL(url);
};

export const uploadExcel = async (excel) => {
  const token = await cookie.get("token");
  return await axios.put(`${proxy}/separates/read`, excel, {
    headers: { Authorization: token },
  });
};
